module.exports = __webpack_public_path__ + "static/media/icon_rounded_square.4115a8ab.svg";